/* Kairos cart v1. No polling, global fetch patching or checkout DOM changes. */
(() => {
  'use strict';
  if (window.KairosCartPremium) return;
  const state = window.KairosCartPremium = { method: 'card', busy: false, checkout: false, stale: false };
  const surfaces = () => [...document.querySelectorAll('kairos-cart-surface')];
  const payments = () => [...document.querySelectorAll('kairos-cart-payment')];
  const root = () => window.Shopify?.routes?.root || '/';
  const url = (path) => `${root()}${path}`;
  const escape = (value) => CSS.escape(String(value));
  const broadcast = () => payments().forEach((payment) => payment.sync?.());
  const scroller = (surface) => surface.closest('.cart-drawer__inner') || surface.querySelector('[data-kc-scroll]');
  // Keep shopping context in this tab; never return to checkout or another site.
  const shoppingKey = 'kairos-shopping-return-v1';
  const restoreKey = 'kairos-shopping-restore-v1';
  function shoppingURL(value) {
    if (!value) return null;
    try {
      const target = new URL(value, location.origin);
      if (target.origin !== location.origin || !/^https?:$/.test(target.protocol)) return null;
      const base = root().replace(/\/$/, '');
      let path = target.pathname;
      if (base && path.startsWith(base + '/')) path = path.slice(base.length);
      if (path === '/collections/all' || path === '/collections/all/') return null;
      if (path !== '/' && !/^\/(products|collections|pages|blogs|search)(\/|$)/.test(path)) return null;
      return target;
    } catch (_) { return null; }
  }
  function storedShopping() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(shoppingKey) || 'null');
      if (!saved || !shoppingURL(saved.href) || Date.now() - saved.time > 14400000) return null;
      return saved;
    } catch (_) { return null; }
  }
  function rememberShopping() {
    const target = shoppingURL(location.href);
    if (!target) return;
    try {
      sessionStorage.setItem(shoppingKey, JSON.stringify({
        href: target.href, y: Math.max(0, window.scrollY || 0), time: Date.now()
      }));
    } catch (_) { /* Normal links still work when storage is unavailable. */ }
  }
  function shoppingDestination() {
    const saved = storedShopping();
    const previous = shoppingURL(document.referrer);
    if (previous && (!saved || new URL(saved.href).pathname !== previous.pathname)) return { href: previous.href, y: 0 };
    return saved || (previous ? { href: previous.href, y: 0 } : { href: new URL(root(), location.origin).href, y: 0 });
  }
  function updateShoppingLinks() {
    const destination = shoppingDestination();
    document.querySelectorAll('[data-kc-resume-shopping]').forEach((link) => { link.href = destination.href; });
  }
  window.addEventListener('pagehide', rememberShopping);
  window.addEventListener('pageshow', () => { rememberShopping(); updateShoppingLinks(); });
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-kc-resume-shopping]');
    if (!link) return;
    const destination = shoppingDestination();
    link.href = destination.href;
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    try { sessionStorage.setItem(restoreKey, JSON.stringify({ ...destination, time: Date.now() })); } catch (_) {}
    // Follow the real link; no history.back(), redirects or timers.
  });
  try {
    const restore = JSON.parse(sessionStorage.getItem(restoreKey) || 'null');
    sessionStorage.removeItem(restoreKey);
    if (restore && shoppingURL(restore.href)?.href === location.href && Date.now() - restore.time < 60000) {
      const resume = () => requestAnimationFrame(() => requestAnimationFrame(() => {
        window.scrollTo({ top: Math.max(0, Number(restore.y) || 0), behavior: 'instant' });
      }));
      if (document.readyState === 'complete') resume();
      else window.addEventListener('load', resume, { once: true });
    }
  } catch (_) {}
  rememberShopping();

  function lock(value) {
    state.busy = value;
    surfaces().forEach((surface) => {
      surface.setAttribute('aria-busy', String(value));
      surface.querySelectorAll('[data-kc-delta], [data-kc-quantity], [data-kc-save-note]').forEach((control) => { control.disabled = value; });
    });
    broadcast();
  }
  function error(surface, message) {
    const node = surface?.querySelector('[data-kc-error]');
    if (!node) return;
    node.textContent = message;
    node.hidden = !message;
  }
  async function request(path, body) {
    const response = await fetch(url(path), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await response.json();
    if (!response.ok) {
      const failure = new Error(typeof data.description === 'string' ? data.description : 'Sepet g\u00fcncellenemedi. L\u00fctfen \u00fcr\u00fcn adedini kontrol edin.');
      failure.rejected = response.status >= 400 && response.status < 500;
      throw failure;
    }
    return data;
  }
  function sectionIds() {
    return [...new Set(surfaces().map((s) => s.dataset.kcSection).concat('cart-counter'))].filter(Boolean).slice(0, 5);
  }
  function snapshot() {
    return surfaces().map((s) => ({
      section: s.dataset.kcSection, context: s.dataset.kcContext,
      scroll: scroller(s)?.scrollTop || 0,
      note: s.querySelector('[data-kc-note]')?.value,
      noteOpen: !!s.querySelector('[data-kc-note]')?.closest('details')?.open
    }));
  }
  function render(sections, saved) {
    // Validate all fragments before changing the DOM. A successful cart request
    // can still return null section HTML; never silently show a stale total.
    const changes = [];
    for (const surface of surfaces()) {
      const html = sections?.[surface.dataset.kcSection];
      if (!html) throw new Error('Sepet \u00f6zeti al\u0131namad\u0131. G\u00fcncel tutar\u0131 g\u00f6rmek i\u00e7in sayfay\u0131 yenileyin.');
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const selector = `kairos-cart-surface[data-kc-context="${escape(surface.dataset.kcContext)}"]`;
      const replacement = doc.querySelector(selector);
      if (!replacement) throw new Error('Sepet g\u00f6r\u00fcn\u00fcm\u00fc al\u0131namad\u0131. L\u00fctfen sayfay\u0131 yenileyin.');
      changes.push([surface, replacement]);
    }
    for (const [surface, replacement] of changes) {
      const previous = saved.find((s) => s.section === surface.dataset.kcSection && s.context === surface.dataset.kcContext);
      if (previous?.note !== undefined && replacement.querySelector('[data-kc-note]')) {
        replacement.querySelector('[data-kc-note]').value = previous.note;
        replacement.querySelector('[data-kc-note]').closest('details').open = previous.noteOpen;
      }
      surface.replaceWith(replacement);
      if (scroller(replacement)) scroller(replacement).scrollTop = previous?.scroll || 0;
    }
    if (sections?.['cart-counter']) {
      const doc = new DOMParser().parseFromString(sections['cart-counter'], 'text/html');
      const source = doc.querySelector('#shopify-section-cart-counter');
      const target = document.querySelector('#cart-counter');
      if (source && target) target.innerHTML = source.innerHTML;
    }
    // Existing controller rebinds a newly rendered header cart button.
    const drawer = document.querySelector('cart-drawer');
    drawer?.setCartLink?.();
    broadcast();
  }
  async function change(surface, item, quantity, focusKind) {
    if (state.busy || state.checkout || state.stale) return;
    if (!Number.isInteger(quantity) || quantity < 0) {
      error(surface, 'L\u00fctfen ge\u00e7erli bir \u00fcr\u00fcn adedi girin.');
      const field = item.querySelector('[data-kc-quantity]');
      if (field) field.value = field.defaultValue;
      return;
    }
    const key = item.dataset.kcKey;
    const context = surface.dataset.kcContext;
    const saved = snapshot();
    const sections = sectionIds();
    error(surface, '');
    lock(true);
    surface.querySelector('[data-kc-status]').textContent = 'Sepet g\u00fcncelleniyor.';
    let completed = false;
    try {
      const cart = await request('cart/change.js', {
        id: key, quantity, sections, sections_url: location.pathname + location.search
      });
      completed = true;
      let fragments = cart.sections;
      if (sections.some((id) => !fragments?.[id])) {
        // One read-only recovery request, never a second quantity mutation.
        const refresh = new URL(location.href);
        refresh.searchParams.set('sections', sections.join(','));
        const response = await fetch(refresh.pathname + refresh.search, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Sepet \u00f6zeti y\u00fcklenemedi. L\u00fctfen sayfay\u0131 yenileyin.');
        fragments = await response.json();
      }
      render(fragments, saved);
      const current = surfaces().find((s) => s.dataset.kcContext === context);
      const currentItem = current?.querySelector(`[data-kc-key="${escape(key)}"]`);
      const focusTarget = currentItem?.querySelector(focusKind || '[data-kc-quantity]') || current?.querySelector('[data-kc-continue]');
      current?.querySelector('[data-kc-status]')?.replaceChildren(document.createTextNode(quantity === 0 ? '\u00dcr\u00fcn sepetinizden kald\u0131r\u0131ld\u0131.' : 'Sepet g\u00fcncellendi.'));
      lock(false);
      focusTarget?.focus({ preventScroll: true });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, source: 'kairos-cart' } }));
    } catch (failure) {
      // A lost response may follow a successful write. Prevent further checkout
      // against an unverified total until a normal reload reconciles the cart.
      state.stale = completed || !failure.rejected;
      const current = surfaces().find((s) => s.dataset.kcContext === context) || surface;
      error(current, state.stale ? 'Sepet bilgisi do\u011frulanamad\u0131. G\u00fcncel adet ve tutar i\u00e7in sayfay\u0131 yenileyin.' : failure.message);
      current.querySelector('[data-kc-status]').textContent = '';
      const input = item.querySelector('[data-kc-quantity]');
      if (input) input.value = input.defaultValue;
    } finally {
      lock(false);
    }
  }
  async function saveNote(surface) {
    const field = surface?.querySelector('[data-kc-note]');
    if (!field || field.value === field.defaultValue) return;
    const note = field.value;
    await request('cart/update.js', { note });
    field.defaultValue = note;
    surface.querySelector('[data-kc-status]').textContent = 'Sipari\u015f notunuz kaydedildi.';
  }
  class KairosCartSurface extends HTMLElement {
    connectedCallback() {
      updateShoppingLinks();
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.addEventListener('click', (event) => {
        if ((state.busy || state.stale) && event.target.closest('[data-kc-bridge]')) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, { ...options, capture: true });
      this.addEventListener('click', (event) => {
        const control = event.target.closest('[data-kc-delta], [data-kc-remove], [data-kc-save-note]');
        if (!control) return;
        event.preventDefault();
        if (state.busy || state.checkout || state.stale) return;
        if (control.matches('[data-kc-save-note]')) {
          lock(true);
          saveNote(this).catch(() => error(this, 'Notunuz kaydedilemedi. L\u00fctfen tekrar deneyin.')).finally(() => lock(false));
          return;
        }
        const item = control.closest('[data-kc-key]');
        const field = item?.querySelector('[data-kc-quantity]');
        if (!item || !field) return;
        let quantity = 0;
        if (control.hasAttribute('data-kc-delta')) {
          const step = Number(field.step) || 1;
          quantity = Number(field.value) + Number(control.dataset.kcDelta) * step;
          if (quantity < Number(field.dataset.kcMin || 1)) quantity = 0;
        }
        change(this, item, Math.max(0, quantity), control.hasAttribute('data-kc-delta') ? `[data-kc-delta="${control.dataset.kcDelta}"]` : null);
      }, options);
      this.addEventListener('change', (event) => {
        if (!event.target.matches('[data-kc-quantity]')) return;
        change(this, event.target.closest('[data-kc-key]'), event.target.valueAsNumber, '[data-kc-quantity]');
      }, options);
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('.kc-item-form')) return;
        event.preventDefault();
        const field = event.target.querySelector('[data-kc-quantity]:focus');
        if (field) change(this, field.closest('[data-kc-key]'), field.valueAsNumber, '[data-kc-quantity]');
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  }
  class KairosCartPayment extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.bridge = this.querySelector('[data-kc-bridge]');
      this.totalCents = Math.max(0, Number(this.dataset.cartTotal) || 0);
      this.currency = this.dataset.cartCurrency || 'TRY';
      this.discountType = 'percentage';
      this.discountValue = Math.max(0, Number(this.dataset.discountFallback) || 5);

      if (!this.bridge) return;

      this.addEventListener('change', (event) => {
        if (!event.target.matches('.kc-method input') || state.checkout) return;
        state.method = event.target.value === 'bank' ? 'bank' : 'card';
        broadcast();
      }, { signal: this.controller.signal });

      this.addEventListener('click', (event) => {
        if (!event.target.closest('[data-kc-continue]')) return;
        event.preventDefault();
        this.proceed();
      }, { signal: this.controller.signal });

      // PaySelect gerçek indirim akışını ve ödeme yöntemi uygunluğunu yönetir.
      this.observer = new MutationObserver(() => this.ready());
      this.observer.observe(this.bridge, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-havale-default-bound']
      });

      this.ready();
    }

    readConfig() {
      try {
        const config = JSON.parse(document.getElementById('havale-config')?.textContent || '{}');
        const value = Number(config.discountValue);

        if (Number.isFinite(value) && value > 0) {
          this.discountValue = value;
          this.discountType = String(config.discountType || 'percentage').toLowerCase();
        }
      } catch (_) {
        // Tema üzerindeki %5 varsayılanı kullanılmaya devam eder.
      }
    }

    formatMoney(cents) {
      const amount = (Number(cents) || 0) / 100;

      if (this.currency === 'TRY') {
        return new Intl.NumberFormat('tr-TR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount) + ' TL';
      }

      try {
        return new Intl.NumberFormat('tr-TR', {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (_) {
        return new Intl.NumberFormat('tr-TR', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      }
    }

    discountCents() {
      const total = this.totalCents;
      const value = Math.max(0, Number(this.discountValue) || 0);

      if (['fixed', 'fixed_amount', 'amount'].includes(this.discountType)) {
        return Math.min(total, Math.round(value * 100));
      }

      return Math.min(total, Math.round(total * value / 100));
    }

    bankTotalCents() {
      return Math.max(0, this.totalCents - this.discountCents());
    }

    offerText() {
      if (['fixed', 'fixed_amount', 'amount'].includes(this.discountType)) {
        return this.formatMoney(this.discountCents()) + ' indirim';
      }

      return '%' + Number(this.discountValue).toLocaleString('tr-TR') + ' indirim';
    }

    updateAmounts() {
      const cardTotal = this.querySelector('[data-kc-card-total]');
      const bankTotal = this.querySelector('[data-kc-bank-total]');
      const saving = this.querySelector('[data-kc-bank-saving]');
      const offer = this.querySelector('[data-kc-offer]');

      if (cardTotal) cardTotal.textContent = this.formatMoney(this.totalCents);
      if (bankTotal) bankTotal.textContent = this.formatMoney(this.bankTotalCents());
      if (saving) saving.textContent = this.formatMoney(this.discountCents()) + ' kazanç';
      if (offer) offer.textContent = this.offerText();
    }

    ready() {
      const card = this.bridge.querySelector('[name="checkout"][data-havale-default-bound]');
      const bank = this.bridge.querySelector('[data-havale-button]');
      if (!card || !bank) return;

      this.card = card;
      this.bank = bank;
      this.observer?.disconnect();
      this.readConfig();
      this.setAttribute('data-enhanced', '');
      this.querySelectorAll('.kc-methods, [data-kc-payment-help], [data-kc-enhanced-actions]').forEach((node) => {
        node.hidden = false;
      });
      this.updateAmounts();
      this.sync();
    }

    sync() {
      this.setAttribute('data-method', state.method);
      this.updateAmounts();

      this.querySelectorAll('.kc-method input').forEach((input) => {
        input.checked = input.value === state.method;
        input.disabled = state.busy || state.checkout || state.stale;
      });

      const button = this.querySelector('[data-kc-continue]');
      if (button) {
        button.disabled = state.busy || state.checkout || state.stale;

        if (state.checkout) {
          button.textContent = 'Ödeme ekranı hazırlanıyor…';
        } else if (state.method === 'bank') {
          button.textContent = 'Havale ile ' + this.formatMoney(this.bankTotalCents()) + ' öde →';
        } else {
          button.textContent = 'Kart ile ödemeye devam et →';
        }
      }

      const help = this.querySelector('[data-kc-payment-help]');
      if (help) {
        help.textContent = state.method === 'bank'
          ? 'Havale / EFT ile ödeyeceğiniz indirimli toplam ' + this.formatMoney(this.bankTotalCents()) + '. ' + this.formatMoney(this.discountCents()) + ' kazançla indirimli ödeme akışına devam edersiniz.'
          : 'Kartla ödenecek toplam ' + this.formatMoney(this.totalCents) + '. Kartınıza uygun taksit seçenekleri PayTR ödeme ekranında gösterilir.';
      }
    }

    paymentError(message) {
      const node = this.querySelector('[data-kc-payment-error]');
      if (!node) return;
      node.textContent = message;
      node.hidden = !message;
    }

    async proceed() {
      if (state.busy || state.checkout || state.stale) return;

      const selected = state.method;
      const control = selected === 'bank' ? this.bank : this.card;

      if (!control?.isConnected || control.disabled) {
        this.paymentError('Ödeme seçeneği henüz hazır değil. Lütfen birkaç saniye sonra tekrar deneyin.');
        return;
      }

      this.paymentError('');
      state.checkout = true;
      broadcast();

      try {
        await saveNote(document.querySelector('kairos-cart-surface[data-kc-context="page"]'));

        if (!this.isConnected || !control.isConnected) {
          throw new Error('Sepet yenilendi. Lütfen ödeme tercihinizi tekrar onaylayın.');
        }

        if (selected === 'bank') {
          let wasDisabled = false;
          this.failureObserver = new MutationObserver(() => {
            if (control.disabled) wasDisabled = true;
            if (wasDisabled && !control.disabled && state.checkout) {
              this.failureObserver.disconnect();
              state.checkout = false;
              broadcast();
              this.paymentError('Havale işlemi başlatılamadı. Tekrar deneyebilir veya kart seçeneğine geçebilirsiniz.');
            }
          });
          this.failureObserver.observe(control, { attributes: true, attributeFilter: ['disabled'] });
        }

        // PaySelect'in gerçek ve uygulama tarafından bağlanmış kontrolünü çalıştırır.
        // İndirim ve ödeme yöntemi uygunluğu uygulama tarafından checkout'a taşınır.
        control.click();
      } catch (failure) {
        state.checkout = false;
        broadcast();
        const current = this.isConnected ? this : payments().find((payment) => payment.hasAttribute('data-enhanced'));
        current?.paymentError(failure.message || 'Ödeme başlatılamadı. Lütfen tekrar deneyin.');
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      this.failureObserver?.disconnect();
    }
  }
  customElements.define('kairos-cart-surface', KairosCartSurface);
  customElements.define('kairos-cart-payment', KairosCartPayment);
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    state.method = 'card';
    state.checkout = false;
    lock(false);
    payments().forEach((payment) => payment.paymentError(''));
  });
})();